import { createApi } from "./client";
import type { ReservationRequest, ReservationResponse } from "../types/models";

export function createReservation(
    apiBase: string,
    companySlug: string,
    payload: ReservationRequest
) {
    const api = createApi(apiBase);

    return api<ReservationResponse>(`/api/companies/${companySlug}/reservations`, {
        method: "POST",
        body: payload,
    });
}
